import { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { addUnreadCounter, fetchUnreadCounter } from 'modules/inbox/store/inbox-slice';
import useWebSocket from 'utils/useWebSocket';
import useCounterSync from 'utils/useCounterSync';

const useCountUnreadInbox = () => {
  const userUuid = useSelector((store: RootState) => store.auth.user?.uuid);
  const unreadCounter = useSelector((store: RootState) => store.inbox.unreadCounter);
  const dispatch = useDispatch();

  const unreadCounterRef = useRef(unreadCounter);
  unreadCounterRef.current = unreadCounter;

  const fetchCounter = useCallback(() => {
    dispatch(fetchUnreadCounter());
  }, [dispatch]);

  // The websocket deltas below are only a fast path. This keeps the badge converging to the
  // server value after missed events, failed requests or a socket drop.
  const syncCounter = useCounterSync(fetchCounter, { enabled: !!userUuid });

  useWebSocket({
    channelName: `users.${userUuid}`,
    enabled: !!userUuid,
    listen: {
      event: '.mention.change',
      callback: (event: any) => {
        // Bump immediately so the badge reacts instantly, then reconcile with the server so a
        // duplicated or already-read mention cannot drift the value upwards.
        if (event?.action === 'create' && unreadCounterRef.current !== null) {
          dispatch(addUnreadCounter(1));
        }

        syncCounter();
      },
    },
  });
};

export default useCountUnreadInbox;
